export default {
  title: 'Envoyer un message - Confirmation',
  information: {
    title: 'Votre message est envoyé',
    confirmationNumber: 'No. {{msgId}}',
  },
};
